import * as React from 'react';
import { Fragment } from 'react';
import {
  DatagridConfigurable,
  DateInput,
  ExportButton,
  FilterButton,
  ReferenceInput,
  SearchInput,
  SelectColumnsButton,
  TextField,
  TopToolbar,
  ShowButton,
  EditButton,
  ReferenceField,
  DeleteWithConfirmButton,
  CreateButton,
  useRecordContext,
  WrapperField,
  NullableBooleanInput,
} from 'react-admin';
import { useCanAccess } from '@react-admin/ra-rbac';

import { useMediaQuery, Divider, Theme } from '@mui/material';
import ComponentList from '../../components/PageComponents/ComponentList';
import { AccountFilter } from '../../components/PageComponents/ComponentList';
import MobileGrid from './MobileGrid';
import { User } from '../../models/user';
import Label, { statusText } from '../../components/Label';
import { StatusLabel } from '../../components/Label/status';
import { useTranslation } from 'react-i18next';
import { Account } from '../../models/account';
import { BulkActionButtons, ListActions, ListButtons } from '../../components/PageComponents/ComponentList';
import { listPermissions } from './create';
import { datagridSx } from "../../components/PageComponents/datagridSx";

const UserList = () => (
  <ComponentList title="Users" subtitle="People with access to the admin, with their account, role and status." /* filters={usersFilters}  */actions={<ListActions ressource="users" filters={usersFilters} />}>
    <TabbedDatagrid />
  </ComponentList>
);

const usersFilters = [
  <AccountFilter />,
];

const CustomDeleteWithConfirmButton = () => {
  const record = useRecordContext();
  const { t }: { t: any } = useTranslation();
  const { isLoading, canAccess } = useCanAccess({
    action: 'delete',
    resource: 'users',
  });
  if (isLoading || !canAccess) return null;

  return (
<DeleteWithConfirmButton confirmTitle={t(`Delete user: ${record.name} ?`)} translateOptions={{ id:"", name: record.name }}/>
  )
}

// Coinhouse internal roles (64 and above) read as primary, client roles as neutral.
const PermissionLevelField = () => {
  const record  = useRecordContext();
  const { t }: { t: any } = useTranslation();
  const permissions = listPermissions();
  const permission = permissions.find((permission) => permission.id === record?.permissionLevel);
  if (!permission) return null;
  return <Label color={permission.id >= 64 ? 'primary' : 'secondary'}>{t(statusText(permission.name))}</Label>;
};

const TabbedDatagrid = () => {
  const { t }: { t: any } = useTranslation();
  const isXSmall = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down('sm')
  );

  return (
    <Fragment>
      <Divider />
      {isXSmall ? (
        <MobileGrid />
      ) : (
        <>
          <DatagridConfigurable
            bulkActionButtons={<BulkActionButtons ressource="users" />}
            rowClick="show"
            omit={[]}
            sx={datagridSx}
          >
            <TextField sortable={false} source="name" />
            <TextField sortable={false} source="email" label="Email" />
            <ReferenceField reference="accounts" source="accountId" label="Account" sortable={false}>
              <TextField sortable={false} source="name" />
            </ReferenceField>
            <WrapperField sortable={false} label="Role">
              <PermissionLevelField />
            </WrapperField>
            <WrapperField label="Status" source='Status' sortable={false}>
              <StatusLabel statusField="status" />
            </WrapperField>
            <ListButtons ressource="users" />
          </DatagridConfigurable>
        </>
      )}
    </Fragment>
  );
};

export default UserList;